import { css, DefaultTheme, ThemeProps } from 'styled-components';
import { TokenConfig } from '../types';
import { InteractionState } from '../utils/enums';
import { LinkProps, LinkState, LinkVariantStateTokenConfig } from './types';

export const getVariantAndState = ({
    variant = 'default',
    disabled,
    inherit,
    standalone,
}: ThemeProps<DefaultTheme> & LinkProps & { inline?: string }) => {
    let state = LinkState.Inline;

    if (disabled) {
        state = LinkState.Disabled;
    } else if (inherit) {
        state = LinkState.Inherit;
    } else if (standalone) {
        state = LinkState.Standalone;
    }

    return { variant, state };
};

export const getStyles = (
    props: ThemeProps<DefaultTheme>,
    config: TokenConfig<LinkVariantStateTokenConfig>,
    interactionState: InteractionState = InteractionState.Default
) => {
    const { variant, state } = getVariantAndState(props);

    return config?.[interactionState]?.[variant]?.[state];
};

export const getTextDecoration = ({ disabled, standalone, underline }: LinkProps) => css`
    text-decoration: ${underline ? 'underline' : 'none'};
    &:hover {
        text-decoration: ${standalone && underline && !disabled ? 'none' : 'underline'};
    }
`;
